"use client"

import { Trophy, CheckCircle2, Flame } from "lucide-react"
import { ProfileStatCard } from "@/components/ui/profile/profile-stat-card"

export function ProfileStats() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <ProfileStatCard
        icon={<Trophy className="w-10 h-10 text-purple-600" />}
        label="Total Points"
        value="1,250"
        color="purple"
      />
      <ProfileStatCard
        icon={<CheckCircle2 className="w-10 h-10 text-teal-600" />}
        label="Tasks Completed"
        value="88"
        color="teal"
      />
      <ProfileStatCard
        icon={<Flame className="w-10 h-10 text-orange-600" />}
        label="Streaks"
        value="12 Days"
        color="orange"
      />
    </div>
  )
}
